import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './LegalPages.css';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <SEO 
        title="Terms & Conditions | The Prisma Global"
        description="Terms and conditions for using The Prisma Global services including digital advertising, manufacturing, real estate, and white-label solutions."
        canonical="/terms-conditions"
      />
      <Navbar />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last Updated: December 23, 2025</p>
          
          <section>
            <h2>1. Introduction</h2>
            <p>Welcome to The Prisma Global. By accessing and using our website and services, you agree to be bound by these Terms and Conditions. Please read them carefully.</p>
          </section>

          <section>
            <h2>2. Company Information</h2>
            <p><strong>The Prisma Global</strong></p>
            <p>Next to Markanday Mandir, Kumtha Naka<br />
            Solapur 413001, Maharashtra, India</p>
            <p>Email: info@theprismaglobal.com<br />
            Phone: +91-9356-107-460</p>
            <p>MSME Registration: UDYAM-MH-32-0255914</p>
          </section>

          <section>
            <h2>3. Services Offered</h2>
            <p>The Prisma Global operates across four strategic divisions:</p>
            <ul>
              <li><strong>Digital Advertising Services:</strong> Political campaign management, brand design, mobile app development, AI business tools</li>
              <li><strong>PrismaTex Sustainable Manufacturing:</strong> Heritage handloom textiles, sustainable fashion manufacturing</li>
              <li><strong>Prisma Terra Real Estate:</strong> Land development, NA plot approvals, Nakshatra Villas, luxury real estate</li>
              <li><strong>White-Label Solutions:</strong> Market-ready platform solutions for businesses</li>
            </ul>
          </section>

          <section>
            <h2>4. Digital Products & Services</h2>
            <p>Our Impact Reports and digital products are delivered electronically. By purchasing digital products:</p>
            <ul>
              <li>You receive immediate access upon successful payment</li>
              <li>Products are for personal or business use only</li>
              <li>Redistribution or resale is strictly prohibited</li>
              <li>All sales are final (see Refund Policy)</li>
            </ul>
          </section>

          <section>
            <h2>5. Pricing & Payments</h2>
            <p>All prices are listed in Indian Rupees (INR). We accept payments through Cashfree Payment Gateway, including:</p>
            <ul>
              <li>Credit/Debit Cards (Visa, Mastercard, RuPay)</li>
              <li>UPI (Google Pay, PhonePe, Paytm)</li>
              <li>Net Banking</li>
              <li>Digital Wallets</li>
            </ul>
            <p>Payments are processed securely through Cashfree. We do not store your payment information.</p>
          </section>

          <section>
            <h2>6. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of your account (if applicable)</li>
              <li>Use our services lawfully and ethically</li>
              <li>Not engage in fraudulent activities</li>
              <li>Respect intellectual property rights</li>
            </ul>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>All content, trademarks, logos, and materials on this website are the property of The Prisma Global. This includes:</p>
            <ul>
              <li>Website design and layout</li>
              <li>Impact Reports and digital content</li>
              <li>Brand names (PrismaTex, Prisma Terra, Discover Solapur™, Eco-Warriors™)</li>
              <li>Images, graphics, and multimedia</li>
            </ul>
            <p>Unauthorized use is prohibited without prior written consent.</p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>The Prisma Global shall not be liable for:</p>
            <ul>
              <li>Indirect, incidental, or consequential damages</li>
              <li>Loss of profits, data, or business opportunities</li>
              <li>Service interruptions or technical issues</li>
              <li>Third-party content or services</li>
            </ul>
            <p>Our total liability shall not exceed the amount paid by you for the specific service.</p>
          </section>

          <section>
            <h2>9. Disclaimer of Warranties</h2>
            <p>Services are provided "as is" without warranties of any kind, either express or implied. We do not guarantee:</p>
            <ul>
              <li>Uninterrupted or error-free service</li>
              <li>Specific business outcomes or results</li>
              <li>Compatibility with all devices or systems</li>
            </ul>
          </section>

          <section>
            <h2>10. Privacy & Data Protection</h2>
            <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your personal information.</p>
          </section>

          <section>
            <h2>11. Termination</h2>
            <p>We reserve the right to terminate or suspend access to our services immediately, without prior notice, for:</p>
            <ul>
              <li>Breach of these Terms and Conditions</li>
              <li>Fraudulent or illegal activities</li>
              <li>Abuse of our services or systems</li>
            </ul>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>These Terms and Conditions are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Solapur, Maharashtra, India.</p>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on this page. Your continued use of our services constitutes acceptance of the modified terms.</p>
          </section>

          <section>
            <h2>14. Contact Us</h2>
            <p>For questions about these Terms and Conditions, please contact us:</p>
            <p>
              Email: info@theprismaglobal.com<br />
              Phone: +91-9356-107-460<br />
              Address: Next to Markanday Mandir, Kumtha Naka, Solapur 413001, Maharashtra, India
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsConditions;